module.exports = __webpack_public_path__ + "img/absorbente1.964df2d5.jpg";